/**
 * Hook for checking if a deployment-level feature is enabled.
 *
 * Usage:
 *   const showInbox = useFeature('inbox')
 *   const showVoice = useFeature('voice')
 */

import { useFeatureStore } from '@/stores/featureStore'

export function useFeature(feature: string): boolean {
  return useFeatureStore((s) => s.isEnabled(feature))
}
